import { s } from "../../../../utilities/common"

export const AlbumIcon = () => {
  return (
    <svg
      style={{ marginLeft: s("20px") }}
      width={s("40")}
      height={s("40")}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.72727 20C7.72727 13.222 13.222 7.72727 20 7.72727C26.778 7.72727 32.2727 13.222 32.2727 20C32.2727 26.778 26.778 32.2727 20 32.2727C13.222 32.2727 7.72727 26.778 7.72727 20ZM20 5C11.7157 5 5 11.7157 5 20C5 28.2843 11.7157 35 20 35C28.2843 35 35 28.2843 35 20C35 11.7157 28.2843 5 20 5Z"
        fill="#303949"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.4935 20C16.4935 18.0634 18.0634 16.4935 20 16.4935C21.9366 16.4935 23.5065 18.0634 23.5065 20C23.5065 21.9366 21.9366 23.5065 20 23.5065C18.0634 23.5065 16.4935 21.9366 16.4935 20ZM20 15.7143C17.6331 15.7143 15.7143 17.6331 15.7143 20C15.7143 22.3669 17.6331 24.2857 20 24.2857C22.3669 24.2857 24.2857 22.3669 24.2857 20C24.2857 17.6331 22.3669 15.7143 20 15.7143Z"
        fill="white"
      />
      <path
        d="M22.7916 20C22.7916 18.4579 21.5421 17.2084 20 17.2084C18.4579 17.2084 17.2084 18.4579 17.2084 20C17.2084 21.5421 18.4579 22.7916 20 22.7916C21.5421 22.7916 22.7916 21.5421 22.7916 20ZM25 20C25 22.7614 22.7614 25 20 25C17.2386 25 15 22.7614 15 20C15 17.2386 17.2386 15 20 15C22.7614 15 25 17.2386 25 20Z"
        fill="#303949"
      />
    </svg>
  )
}
